import 'axios';
import './axiosInstance.js';
import './responses.js';
import fetchFromApi from './fetchFromApi.js';

/**
 * Fetches all breach events in the system.
 *
 * @param {object} [options] a configuration object
 * @param {string} [options.domain] a domain by which to filter the results
 * (default: all domains)
 * @param {string} [options.baseUrl] a custom base URL for the
 * haveibeenpwned.com API endpoints (default: `https://haveibeenpwned.com/api`)
 * @param {string} [options.userAgent] a custom string to send as the User-Agent
 * field in the request headers (default: `hibp <version>`)
 * @returns {Promise<Breach[]>} a Promise which resolves to an array of breach
 * objects (an empty array if no breaches were found), or rejects with an Error
 * @example
 * breaches()
 *   .then(data => {
 *     if (data) {
 *       // ...
 *     } else {
 *       // ...
 *     }
 *   })
 *   .catch(err => {
 *     // ...
 *   });
 * @example
 * breaches({ domain: 'adobe.com' })
 *   .then(data => {
 *     if (data) {
 *       // ...
 *     } else {
 *       // ...
 *     }
 *   })
 *   .catch(err => {
 *     // ...
 *   });
 * @alias module:breaches
 */
var breaches = function breaches() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var endpoint = '/breaches?';
    var params = [];
    if (options.domain) {
        params.push("domain=".concat(encodeURIComponent(options.domain)));
    }
    return fetchFromApi("".concat(endpoint).concat(params.join('&')), {
        baseUrl: options.baseUrl,
        userAgent: options.userAgent
    });
};

export default breaches;
//# sourceMappingURL=breaches.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/breaches.js
// module id = ./node_modules/hibp/es/breaches.js
// module chunks = 2